import { useFormikContext } from "formik";
import { useUnit } from "Pages/Units/useUnit";
import { GeneralInfo } from "./GeneralInfo";
import { Attributes } from "./Attributes";
import { AttendancePeriods } from "./AttendancePeriods";
import { RapidTestsSection } from "./RapidTestsSection";
import { Parkings } from "./Parkings";
import { AddressInfo } from "./AddressInfo";
import { ImagesPanelV2 } from "./ImagesPanelV2";
import { AdditionalInfo } from "./AdditionalInfo";
import { FormUnitProps, UnitFormValues } from "./schemas";
import { Transports } from "./Transports";

export const FormUnit = ({ unitId, hasRapidTests }: FormUnitProps) => {
  const { values, setFieldValue } = useFormikContext<UnitFormValues>();

  const { handleDeleteImage, showApiImages } = useUnit(unitId);

  const { image_map } = values as UnitFormValues;

  const handleSetImages = (field: string, e: any) => {
    const val = values[field];
    const updatedValues = new Set([...val, ...e]);
    setFieldValue(field, Array.from(updatedValues));
  };

  const handleSetUnitMap = (field: string, e: any) => {
    setFieldValue(field, e[0]);
  };

  const imageMap = image_map ? [image_map] : [];

  const handleDeleteImageMap = () => {
    setFieldValue("image_map", null);
  };

  return (
    <div className="page-content">
      <div className="row">
        <div className="md-8">
          <div className="row">
            <div className="sm-12">
              <GeneralInfo unitId={unitId} />
            </div>
          </div>
        </div>
        <div className="md-4">
          <div className="row">
            <div className="sm-12">
              <Attributes />
            </div>
          </div>
        </div>
        <div className="sm-12">
          <AddressInfo />
        </div>
        <div className="sm-12">
          <AttendancePeriods />
        </div>
        {hasRapidTests && (
          <div className="sm-12">
            <RapidTestsSection />
          </div>
        )}

        <div className="sm-12">
          <ImagesPanelV2
            title="Imagens da Unidade"
            sendFormData={(e: any) => handleSetImages("images", e)}
            imageList={values.images}
            previewImages={showApiImages}
            onDeleteImage={handleDeleteImage}
          />

          <ImagesPanelV2
            imageList={imageMap}
            previewImages={[]}
            title="Imagem do Mapa"
            sendFormData={(e: any) => handleSetUnitMap("image_map", e)}
            onDeleteImage={handleDeleteImageMap}
          />
        </div>

        <AdditionalInfo />

        <div className="md-12">
          <Parkings />
        </div>

        <div className="md-12">
          <Transports />
        </div>
      </div>
    </div>
  );
};
